import { render, staticRenderFns } from "./FilterSelect.vue?vue&type=template&id=487d05e0&scoped=true&"
import script from "./FilterSelect.vue?vue&type=script&lang=js&"
export * from "./FilterSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d05e0",
  null
  
)

export default component.exports